module.exports = __webpack_public_path__ + "static/media/1.25-hour.528b557a.png";